import { useId } from 'react';

import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconChipTan = (iconProps: ChkIconProps) => {
  const maskId = useId();

  return (
    <ChkSvgWrapper {...iconProps}>
      <g>
        <path
          d="M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <g>
          <mask id={maskId} fill="white">
            <rect x="6" y="7" width="12" height="6" rx="1" />
          </mask>
          <rect
            x="6"
            y="7"
            width="12"
            height="6"
            rx="1"
            stroke="currentColor"
            strokeWidth="4"
            mask={`url(#${maskId})`}
          />
        </g>
      </g>
    </ChkSvgWrapper>
  );
};
